import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const MobileDevice = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="mobile-device-icon"
    height={height}
    width={width}
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M4.5 0C3.67157 0 3 0.671573 3 1.5V12H13V1.5C13 0.671573 12.3284 0 11.5 0H4.5Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M13 13H3V14.5C3 15.3284 3.67157 16 4.5 16H11.5C12.3284 16 13 15.3284 13 14.5V13Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
